import { api } from '../instance';
export const getMe = () => {
    return api.get('/auth/me');
};
//# sourceMappingURL=get-me.api.js.map